// @flow

import React from 'react';
import styles from './actionButton.scss';

const ActionButton = ({
  id = 'my-button',
  isDisabled = false,
  onClick = () => {},
  theme = 'action-button',
  buttonText = 'Button',
  disabledClass = '',
  csx = {}
}) => {
  return (
    <div
      id={id}
      onClick={onClick}
      className={`${styles[theme]} ${isDisabled ? styles[disabledClass] : ''}`}
      style={csx}
    >
      {buttonText}
    </div>
  );
};

export default ActionButton;
